class Accordeon {
  constructor() {
    this.accordeons = document.querySelectorAll("accordeon");
    this.accordeons.forEach((accordeon) => {
      const header = accordeon.querySelector(".accordeon-header");
      header.addEventListener("click", () => {
        accordeon.toggleAttribute("open");
      });
    });
  }

  removeAllOpen() {
    this.accordeons.forEach((accordeon) => {
      accordeon.removeAttribute("open");
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Accordeon();
});
